import Vue from 'vue';

export class LayoutComponent extends Vue {


}
